/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Logistics_CarrierInputs */

const en_logistics_carrier = /** @type {(inputs: Logistics_CarrierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logistics Carrier`)
};

const es_logistics_carrier = /** @type {(inputs: Logistics_CarrierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transportista Logístico`)
};

const fr_logistics_carrier = /** @type {(inputs: Logistics_CarrierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transporteur logistique`)
};

const de_logistics_carrier = /** @type {(inputs: Logistics_CarrierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logistikunternehmen`)
};

const id_logistics_carrier = /** @type {(inputs: Logistics_CarrierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurir Logistik`)
};

/** @type {(inputs: Logistics_CarrierInputs) => LocalizedString} */
const ja_logistics_carrier = en_logistics_carrier;

/** @type {(inputs: Logistics_CarrierInputs) => LocalizedString} */
const zh_logistics_carrier = en_logistics_carrier;

/** @type {(inputs: Logistics_CarrierInputs) => LocalizedString} */
const ar_logistics_carrier = en_logistics_carrier;

/** @type {(inputs: Logistics_CarrierInputs) => LocalizedString} */
const it_logistics_carrier = en_logistics_carrier;

/** @type {(inputs: Logistics_CarrierInputs) => LocalizedString} */
const ru_logistics_carrier = en_logistics_carrier;

/** @type {(inputs: Logistics_CarrierInputs) => LocalizedString} */
const pt_logistics_carrier = en_logistics_carrier;

/** @type {(inputs: Logistics_CarrierInputs) => LocalizedString} */
const ko_logistics_carrier = en_logistics_carrier;

/**
* | output |
* | --- |
* | "Logistics Carrier" |
*
* @param {Logistics_CarrierInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const logistics_carrier = /** @type {((inputs?: Logistics_CarrierInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Logistics_CarrierInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_logistics_carrier(inputs)
	if (locale === "es") return es_logistics_carrier(inputs)
	if (locale === "fr") return fr_logistics_carrier(inputs)
	if (locale === "de") return de_logistics_carrier(inputs)
	if (locale === "ja") return ja_logistics_carrier(inputs)
	if (locale === "zh") return zh_logistics_carrier(inputs)
	if (locale === "ar") return ar_logistics_carrier(inputs)
	if (locale === "id") return id_logistics_carrier(inputs)
	if (locale === "it") return it_logistics_carrier(inputs)
	if (locale === "ru") return ru_logistics_carrier(inputs)
	if (locale === "pt") return pt_logistics_carrier(inputs)
	return ko_logistics_carrier(inputs)
});